import React, { useState, useEffect } from "react";
import {
	Box,
	Button,
	Typography,
	Modal,
	Checkbox,
	FormControlLabel,
	FormGroup,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
	handleComplianceOpen,
	setComplianceChecked,
} from "../../redux/slices/contentSlice/contentForm/contentForm";
import {
	handleComplete,
	handleStep,
} from "../../redux/slices/addNewContentStepsSlice";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "80%",
	bgcolor: "background.paper",
	boxShadow: 24,
	borderRadius: "30px",
	maxHeight: "80vh", // Set max height for the main container
	overflow: "hidden", // Prevent any overflow outside this container
	display: "flex",
	flexDirection: "column",
};

const ComplianceModal = ({ open, handleClose, formik }) => {
	const dispatch = useDispatch();
	const complianceChecklist = [
		"I confirm that all content is legally owned by me and does not infringe on copyrights or intellectual property rights of any third-party rights and ownerships.",
		"I confirm that I have obtained all necessary clearances and permissions for music, clips or other copyrighted materials.",
		"I confirm that the content I am uploading adheres to the Platform’s content guidelines.",
		"I confirm that the content is free from any images, videos, displays, language and/or audio that is considered, directly, indirectly or by inference, offensive, pornographic, defamatory, libelous, promoting terrorism, unlawful violence and/or violates the applicable laws of the Territory/Country where the content is being published.",
		"I confirm that the content uploaded does not discredit or disrespect religious, cultural, political, ethnic, gender and/or social, sensitivities of the Country where the content is being published.",
		"I confirm that content adheres to appropriate age and content ratings.",
		"I confirm that the content uploaded is without any logo, disclaimer ticker, blur footage, image and/or banner which is not part of the content as originally produced.",
		"I confirm that I have read and agree to the platform’s terms and conditions.",
		"I confirm that the content uploaded does not discredit or disrespect religious and/or cultural sentiments of the Country where the content is being published.",
		"I confirm that all this checklist is correct and true to the best of my knowledge and beliefs, and nothing has been concealed therefrom;",
		"That I have read, understood, and agreed the terms of this checklist and have executed this with my own freewill without any force, duress and/or coercion.",
	];
	const [checked, setChecked] = useState(
		Array(complianceChecklist.length).fill(false)
	);
	const [allChecked, setAllChecked] = useState(false);
	const [selectAll, setSelectAll] = useState(false);

	useEffect(() => {
		setAllChecked(checked.every(Boolean));
	}, [checked]);

	useEffect(() => {
		if (selectAll) {
			setChecked(Array(complianceChecklist.length).fill(true));
		} else {
			setChecked(Array(complianceChecklist.length).fill(false));
		}
	}, [selectAll]);

	const handleChange = (index) => (event) => {
		const newChecked = [...checked];
		newChecked[index] = event.target.checked;
		setChecked(newChecked);
		setSelectAll(newChecked.every(Boolean));
	};

	const handleSelectAllChange = (event) => {
		setSelectAll(event.target.checked);
	};

	const handleSubmit = () => {
		console.log("Checklist submitted:", checked);
		dispatch(setComplianceChecked(true));
		dispatch(handleComplete());
		handleClose();
	};

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="compliance-checklist-modal"
			aria-describedby="compliance-checklist-description"
		>
			<Box sx={style}>
				{/* Header */}
				<Box
					component={"div"}
					sx={{
						backgroundColor: "#000",
						p: 4,
						borderTopRightRadius: "30px",
						borderTopLeftRadius: "30px",
					}}
				>
					<Typography
						id="compliance-checklist-modal"
						variant="h6"
						component="h2"
						color={"secondary"}
					>
						Content Guidelines
					</Typography>
				</Box>

				{/* Scrollable Content */}
				<Box
					sx={{
						padding: 4,
						overflowY: "auto", // Enables vertical scrolling
						flex: 1, // Ensures this section takes the remaining space
					}}
				>
					<FormGroup>
						{complianceChecklist.map((item, index) => (
							<FormControlLabel
								key={index}
								control={
									<Checkbox
										checked={checked[index]}
										onChange={handleChange(index)}
									/>
								}
								label={item}
							/>
						))}
						<FormControlLabel
							control={
								<Checkbox
									checked={selectAll}
									onChange={handleSelectAllChange}
								/>
							}
							label="Select All"
						/>
					</FormGroup>
				</Box>

				{/* Footer */}
				<Box sx={{ padding: 4, borderTop: "1px solid #ddd" }}>
					<Button
						variant="contained"
						color="primary"
						onClick={handleSubmit}
						sx={{ float: "right", textTransform: "inherit" }}
						disabled={!allChecked}
					>
						Accept and Continue
					</Button>
				</Box>
			</Box>
		</Modal>
	);
};

export default ComplianceModal;
